angular
        .module('topTitleInfoSearch.components', [])
        .component('topTitleInfoSearch', {
            templateUrl: 'ng/components/topTitleInfoSearch/topTitleInfoSearch.html',
            bindings: {
                name: '@',
                icon: '@',
                openModal: '&' ,
                actionBar:'<'   
            },
            controllerAs: 'topTitleInfoSearchCtrl',
            controller: function ($scope, $translate) {
                var self = this;
                self.$onInit = function () {  
                	
                }
                self.clickIconModal = function(){
                    self.openModal();
                }
            }
        });
